import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap';

var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1;
var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd
}
if (mm < 10) {
    mm = '0' + mm
}
today = yyyy + '-' + mm + '-' + dd;

export const Page2Address = ({ errors, touched, values, state, props, onValueChange,
    setFieldValue, onResidentIdemIdentity, requestResidentialCities }) => (
    <React.Fragment>
        <FormGroup tag="fieldset">
            <legend>Alamat Sesuai Identitas</legend>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>Alamat<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="Address1" bsSize="sm" invalid={errors.Address1 && touched.Address1} maxLength={100} />
                        {errors.Address1 && touched.Address1 ? (
                            <FormFeedback>{errors.Address1}</FormFeedback>
                        ) : null}
                        {/* <Input tag={Field} name="Address2" bsSize="sm" maxLength={40} />*/}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Negara<span className="text-danger">*</span></Label>
                        <Field component="select" name="Country" disabled={true}
                            className={errors.Country && touched.Country ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            <option value="ID">Indonesia</option>
                        </Field>
                        {errors.Country && touched.Country ? (
                            <FormFeedback>{errors.Country}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Provinsi<span className="text-danger">*</span> </Label>
                        <Field component="select" name="ProvinceId"
                            className={errors.ProvinceId && touched.ProvinceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onValueChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.provinces.map((province, i) =>
                                <option key={i} value={province.Id}>{province.Name}</option>
                            )}
                        </Field>
                        {errors.ProvinceId && touched.ProvinceId ? (
                            <FormFeedback>{errors.ProvinceId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Kota<span className="text-danger">*</span></Label>
                        <Field component="select" name="CityId"
                            className={errors.CityId && touched.CityId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onValueChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.cities ? props.cities.map((city, i) =>
                                <option key={i} value={city.Id}>{city.Name}</option>
                            ) : null}
                        </Field>
                        {errors.CityId && touched.CityId ? (
                            <FormFeedback>{errors.CityId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>

            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Kecamatan<span className="text-danger">*</span></Label>
                        <Field component="select" name="SubDistrict"
                            className={errors.SubDistrict && touched.SubDistrict ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onValueChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.districts ? props.districts.map((item, i) =>
                                <option key={i} value={item.Name}>{item.Name}</option>
                            ) : null}
                        </Field>
                        {/*   <Input tag={Field} name="SubDistrict" bsSize="sm" invalid={errors.SubDistrict && touched.SubDistrict} />*/}
                        {errors.SubDistrict && touched.SubDistrict ? (
                            <FormFeedback>{errors.SubDistrict}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Kelurahan<span className="text-danger">*</span></Label>
                        <Field component="select" name="Village"
                            className={errors.Village && touched.Village ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onValueChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.subDistricts ? props.subDistricts.map((item, i) =>
                                <option key={i} value={item.Name}>{item.Name}</option>
                            ) : null}
                        </Field>
                        {/* <Input tag={Field} name="Village" bsSize="sm" invalid={errors.Village && touched.Village} />*/}
                        {errors.Village && touched.Village ? (
                            <FormFeedback>{errors.Village}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>RT<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="RT" type="number" bsSize="sm" maxLength="3" invalid={errors.RT && touched.RT} />
                        {errors.RT && touched.RT ? (
                            <FormFeedback>{errors.RT}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>RW<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="RW" type="number" bsSize="sm" maxLength="3" invalid={errors.RW && touched.RW} />
                        {errors.RW && touched.RW ? (
                            <FormFeedback>{errors.RW}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="2">
                    <FormGroup>
                        <Label>Kode Pos<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="tel" maxLength="5" name="PostalCode" bsSize="sm" readOnly
                            invalid={errors.PostalCode && touched.PostalCode}
                        />
                        {errors.PostalCode && touched.PostalCode ? (
                            <FormFeedback>{errors.PostalCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <legend>Alamat Tempat Tinggal</legend>
            <Row>
                <Col md="12">
                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" name="ResidentialAddressIdem" checked={values.ResidentialAddressIdem}
                                onChange={(e) => onResidentIdemIdentity(e, setFieldValue, values, requestResidentialCities)} />
                            Sesuai Alamat Identitas
                        </Label>
                    </FormGroup>
                </Col>
            </Row>

            {(values.ResidentialAddressIdem === false) ?
                <div>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label>Alamat<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="ResidentialAddressLine1" bsSize="sm" invalid={errors.ResidentialAddressLine1 && touched.ResidentialAddressLine1} maxLength={40}
                                    readOnly={values.ResidentialAddressIdem}
                                />
                                {errors.ResidentialAddressLine1 && touched.ResidentialAddressLine1 ? (
                                    <FormFeedback>{errors.ResidentialAddressLine1}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>


                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Negara<span className="text-danger">*</span></Label>
                                <Field component="select" name="ResidentialAddressCountry" disabled
                                    className={errors.ResidentialAddressCountry && touched.ResidentialAddressCountry ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                >
                                    <option value="">-- Pilih --</option>
                                    <option value="ID">Indonesia</option>
                                </Field>
                                {errors.ResidentialAddressCountry && touched.ResidentialAddressCountry ? (
                                    <FormFeedback>{errors.ResidentialAddressCountry}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Provinsi<span className="text-danger">*</span> </Label>
                                <Field component="select" name="ResidentialAddressprovinceId"
                                    className={errors.ResidentialAddressprovinceId && touched.ResidentialAddressprovinceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                    onChange={(e) => onValueChange(e, setFieldValue)}
                                    disabled={values.ResidentialAddressIdem}
                                >
                                    <option value="">-- Pilih --</option>
                                    {props.provinces.map((province, i) =>
                                        <option key={i} value={province.Id}>{province.Name}</option>
                                    )}
                                </Field>
                                {errors.ResidentialAddressprovinceId && touched.ResidentialAddressprovinceId ? (
                                    <FormFeedback>{errors.ResidentialAddressprovinceId}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>City<span className="text-danger">*</span></Label>
                                <Field component="select" name="ResidentialAddressCityId"
                                    className={errors.ResidentialAddressCityId && touched.ResidentialAddressCityId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                    disabled={values.ResidentialAddressIdem} onChange={(e) => onValueChange(e, setFieldValue)} 
                                >
                                    <option value="">-- Pilih --</option>
                                    {props.residentialCities ? props.residentialCities.map((city, i) =>
                                        <option key={i} value={city.Id}>{city.Name}</option>
                                    ) : null}
                                </Field>
                                {errors.ResidentialAddressCityId && touched.ResidentialAddressCityId ? (
                                    <FormFeedback>{errors.ResidentialAddressCityId}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Kecamatan<span className="text-danger">*</span></Label>
                                <Field component="select" name="ResidentialAddressSubDistrict"
                                    className={errors.ResidentialSubDistrict && touched.ResidentialSubDistrict ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                    onChange={(e) => onValueChange(e, setFieldValue)} >
                                    <option value="">-- Pilih --</option>
                                    {props.residentialDistricts ? props.residentialDistricts.map((item, i) =>
                                        <option key={i} value={item.Name}>{item.Name}</option>
                                    ) : null}
                                </Field>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Kelurahan<span className="text-danger">*</span></Label>
                                <Field component="select" name="ResidentialAddressVillage"
                                    className={errors.ResidentialAddressVillage && touched.ResidentialAddressVillage ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                    onChange={(e) => onValueChange(e, setFieldValue)} >
                                    <option value="">-- Pilih --</option>
                                    {props.residentialSubDistricts ? props.residentialSubDistricts.map((item, i) =>
                                        <option key={i} value={item.Name}>{item.Name}</option>
                                    ) : null}
                                </Field>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>RT<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="RT" type="number" bsSize="sm" maxLength="3" invalid={errors.RT && touched.RT} />
                                {errors.RT && touched.RT ? (
                                    <FormFeedback>{errors.RT}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>RW<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="RW" type="number" bsSize="sm" maxLength="3" invalid={errors.RW && touched.RW} />
                                {errors.RW && touched.RW ? (
                                    <FormFeedback>{errors.RW}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>Kode Pos<span className="text-danger">*</span></Label>
                                <Input tag={Field} type="tel" maxLength={5} name="ResidentialAddressPostalCode" bsSize="sm" readOnly
                                    invalid={errors.ResidentialAddressPostalCode && touched.ResidentialAddressPostalCode}
                                />
                                {errors.ResidentialAddressPostalCode && touched.ResidentialAddressPostalCode ? (
                                    <FormFeedback>{errors.ResidentialAddressPostalCode}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>
                </div> : null}
        </FormGroup>
        <FormGroup>
            <legend>Data Kontak</legend>
            <Row>
                <Col md="2">
                    <FormGroup>
                        <Label>Kode Area<span className="text-danger">*</span></Label>
                        <Input tag={Field} placeholder="(cth. 021xx)" type="tel" maxLength="4" name="HomePhoneAreaCode" bsSize="sm"
                            invalid={errors.HomePhoneAreaCode && touched.HomePhoneAreaCode} />
                        {errors.HomePhoneAreaCode && touched.HomePhoneAreaCode ? (
                            <FormFeedback>{errors.HomePhoneAreaCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>No Telp Rumah<span className="text-danger">*</span></Label>
                        <Row>
                            <Col md="4"></Col>
                            <Input tag={Field} name="HomePhone" bsSize="sm" type="string" invalid={errors.HomePhone && touched.HomePhone} />
                            {errors.HomePhone && touched.HomePhone ? (
                                <FormFeedback>{errors.HomePhone}</FormFeedback>
                            ) : null}
                        </Row>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>No Handphone<span className="text-danger">*</span></Label>
                        <Input tag={Field} placeholder="(cth. 081xx)" name="MobilePhone" bsSize="sm" type="tel" readOnly={values.BankCode2 === "BRI"}
                            invalid={errors.MobilePhone && touched.MobilePhone} />
                        {errors.MobilePhone && touched.MobilePhone ? (
                            <FormFeedback>{errors.MobilePhone}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Konfirmasi No Handphone<span className="text-danger">*</span></Label>
                        <Input tag={Field} placeholder="(cth. 081xx)" name="MobilePhoneConfirmation" bsSize="sm" type="tel" readOnly={values.BankCode2 === "BRI"}
                            invalid={errors.MobilePhoneConfirmation && touched.MobilePhoneConfirmation} />
                        {errors.MobilePhoneConfirmation && touched.MobilePhoneConfirmation ? (
                            <FormFeedback>{errors.MobilePhoneConfirmation}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            {/*
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Email<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="Email" type="email" bsSize="sm"
                            invalid={errors.Email && touched.Email} />
                        {errors.Email && touched.Email ? (
                            <FormFeedback>{errors.Email}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Konfirmasi Email<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="EmailConfirmation" type="email" bsSize="sm"
                            invalid={errors.EmailConfirmation && touched.EmailConfirmation} />
                        {errors.EmailConfirmation && touched.EmailConfirmation ? (
                            <FormFeedback>{errors.EmailConfirmation}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            */}
        </FormGroup>
        {/* END: Data Alamat */}
    </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/Page2Address.js